/**
 * WHYSHIFT Field Notes — tabs, sort, filter, and show-more.
 */
function initWhyshiftFieldNotes(section) {
  if (section.dataset.whyshiftFieldNotesInit === 'true') return;
  section.dataset.whyshiftFieldNotesInit = 'true';

  const initialCount = Number(section.dataset.initialCount || 3);
  const batchSize = Number(section.dataset.batchSize || initialCount);
  const reviewsList = section.querySelector('[data-whyshift-reviews-list]');
  const showMoreButton = section.querySelector('[data-whyshift-show-more]');
  const sortSelect = section.querySelector('[data-whyshift-sort]');
  const filterSelect = section.querySelector('[data-whyshift-filter]');
  const tabButtons = [...section.querySelectorAll('[data-whyshift-tab]')];
  const tabPanels = [...section.querySelectorAll('[data-whyshift-panel]')];

  if (!reviewsList) return;

  let visibleLimit = initialCount;

  const getReviews = () => [...reviewsList.querySelectorAll('[data-review-id]')];

  const applyReviewState = () => {
    const filterValue = filterSelect?.value || 'all';
    const sortValue = sortSelect?.value || 'recent';
    let reviews = getReviews();

    if (filterValue !== 'all') {
      reviews = reviews.filter((review) => review.dataset.rating === filterValue);
    }

    if (sortValue === 'helpful') {
      reviews.sort((a, b) => Number(b.dataset.helpful) - Number(a.dataset.helpful));
    } else if (sortValue === 'highest') {
      reviews.sort((a, b) => Number(b.dataset.rating) - Number(a.dataset.rating));
    } else if (sortValue === 'lowest') {
      reviews.sort((a, b) => Number(a.dataset.rating) - Number(b.dataset.rating));
    }

    reviews.forEach((review, index) => {
      reviewsList.appendChild(review);
      const hidden = index >= visibleLimit;
      review.hidden = hidden;
      review.classList.toggle('whyshift-field-notes__review--hidden', hidden);
    });

    if (showMoreButton) {
      showMoreButton.hidden = visibleLimit >= reviews.length;
    }
  };

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.dataset.whyshiftTab;

      tabButtons.forEach((tabButton) => {
        const isActive = tabButton === button;
        tabButton.classList.toggle('is-active', isActive);
        tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      tabPanels.forEach((panel) => {
        panel.hidden = panel.dataset.whyshiftPanel !== target;
      });
    });
  });

  sortSelect?.addEventListener('change', () => {
    visibleLimit = initialCount;
    applyReviewState();
  });

  filterSelect?.addEventListener('change', () => {
    visibleLimit = initialCount;
    applyReviewState();
  });

  showMoreButton?.addEventListener('click', () => {
    visibleLimit += batchSize;
    applyReviewState();
  });

  applyReviewState();
}

function initAllWhyshiftFieldNotes() {
  document.querySelectorAll('.whyshift-field-notes').forEach(initWhyshiftFieldNotes);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllWhyshiftFieldNotes);
} else {
  initAllWhyshiftFieldNotes();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.whyshift-field-notes') || event.target.closest('.whyshift-field-notes');
  if (section) initWhyshiftFieldNotes(section);
});

document.addEventListener('shopify:block:select', (event) => {
  const section = event.target.closest('.whyshift-field-notes');
  if (!section) return;

  const blockId = event.detail?.blockId;
  if (!blockId) return;

  const review = section.querySelector(`[data-review-id="${blockId}"]`);
  if (review) {
    review.hidden = false;
    review.classList.remove('whyshift-field-notes__review--hidden');
  }
});
